import { useContext } from 'react';
import AnalyticsContext from 'ext/lib/analytics';
import type { AnalyticsClient } from 'ext/lib/analytics';

export default function useAnalytics(): AnalyticsClient {
  return useContext(AnalyticsContext);
}
